import { ChangeEvent, FC, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Radio } from '@blueprint/ui';
import triggerTracking from '@blueprint/tracking';

import {
    updateCurrentSortOrder,
    selectSortOrderOptions,
    selectCurrentSortOrder
} from '../../reducers/listingsSortOrder';
import {
    RadioButtonGroup,
    SometimesInlineRadioWrapper
} from './Filters.styles';
import { SearchContext, SearchPageType, SearchSource } from '../SearchContext';

type Props = {
    userAlertId: string | null;
    currentSearchSource: SearchSource;
    searchType: SearchPageType;
};

const defaultInBracketsText = '(default)';

export const SelectSortOrder: FC<Props> = (props) => {
    const { currentSearchSource } = props;
    const reduxDispatch = useDispatch();

    const options = useSelector(selectSortOrderOptions);
    const currentSortOrder = useSelector(selectCurrentSortOrder);

    const { dispatch } = useContext(SearchContext);

    const onChange = (evt: ChangeEvent<HTMLInputElement>) => {
        const {
            target: { value: sortOrder }
        } = evt;
        dispatch({ type: 'SET_SEARCH_SOURCE', payload: currentSearchSource });
        reduxDispatch(updateCurrentSortOrder(sortOrder));
        triggerTracking({
            event: 'GAEvent',
            eventCategory: 'search results',
            eventAction: 'click',
            eventLabel:
                sortOrder === 'newest_listings'
                    ? 'sort_most_recent'
                    : `sort_${sortOrder}`
        });
    };

    return (
        <RadioButtonGroup>
            {options?.map((option, idx) => (
                <SometimesInlineRadioWrapper key={option.value}>
                    <Radio
                        label={`${option.label}${
                            idx === 0 ? ` ${defaultInBracketsText}` : ''
                        }`}
                        value={option.value}
                        id={option.value}
                        onChange={onChange}
                        checked={option.value === currentSortOrder}
                    />
                </SometimesInlineRadioWrapper>
            ))}
        </RadioButtonGroup>
    );
};
